import * as React from "react";
import { useState, useEffect } from "react";
import axios from "axios";
import { APIURL } from "../../config";
import moment from "moment";
import { Box } from "@mui/material";
import { DataGridPro } from '@mui/x-data-grid-pro';
import './reports.css';

export default function CaseManagerCaseload(props) {
    const [isLoading, setIsLoading] = useState(true);
    const [caseLoadData, setCaseLoadData] = useState([]);

    useEffect(() => {
        async function fetchData() {
            let caseLoadData = await axios.get(APIURL + "/customers/getAssociatedCustomersAndTaskTypes", {
                params: { compID: props.comp_id, empID: props.user.emp_id, empType: props.user.type },
            });

            let rows = caseLoadData.data.map((data, idx) => {
                let caseLoadData = {
                    id: idx,
                    emp_id: data.pro_manager_id,
                    emp_name: [data.ManagerFirstName, data.ManagerLastName].filter(Boolean).join(' '),
                    pro_id: data.pro_id,
                    pro_title: data.pro_title,
                    cus_name: data.cus_name,
                    DDDID: data.DDDID,
                    cus_medicaid_id: data.medicaid_id,
                    cus_task_types: data.cusTaskTypes ? data.cusTaskTypes.map((item) => item.EntityValue).join(', ') : '-',
                };
                return caseLoadData;
            });

            setCaseLoadData(rows);
            setIsLoading(false);
        }

        fetchData();
    }, []);

    const columns = [
        // { field: "id", headerName: "ID", width: 70 },
        { field: "emp_id", headerName: "Employee ID", width: 110 },
        { field: "emp_name", headerName: "Case Manager", width: 220 },
        { field: "pro_id", headerName: "Case ID", width: 90 },
        { field: "pro_title", headerName: "Case Name", width: 260 },
        { field: "cus_name", headerName: "Customer Name", width: 200 },
        { field: "DDDID", headerName: "DDDID", width: 100 },
        { field: "cus_medicaid_id", headerName: "Customer Medicaid ID", width: 200 },
        { field: "cus_task_types", headerName: "Associated Task Types", width: 800 },
    ];

    return (
        <div>
            {isLoading ?
                <div className="d-flex flex-row w-100 justify-content-center mt-5">
                    <div className="spinner-border text-primary" role="status">
                        <span className="sr-only">Loading...</span>
                    </div>
                </div>
                :
                <div style={{ width: '100%', height: "calc(100vh - 150px)" }}>
                    <DataGridPro
                        initialState={{
                            sorting: { sortModel: [{ field: "cus_name", sort: "asc" }] },
                            density: 'compact',
                        }}
                        getRowId={(row) => row.id}
                        rows={caseLoadData}
                        columns={columns}
                        checkboxSelection={false}
                        disableRowSelectionOnClick
                        showToolbar />
                </div>
            }
        </div>
    );
};